<template>
  <div v-show="visible" class="keyboard-wrapper" ref="keyboardContainer">
    <div class="keyboard-header">
      <button class="chevron-virtualKeyboard" @click="closeKeyboard">
        <svg
            class="chevron-virtualKeyboard__icon"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M17.9543 6.61598C17.7199 6.38164 17.402 6.25 17.0706 6.25C16.7391 6.25
            16.4212 6.38164 16.1868 6.61598L9.99933 12.8035L3.81183 6.61598C3.57608
            6.38829 3.26032 6.26229 2.93258 6.26514C2.60483 6.26799 2.29132 6.39945
            2.05956 6.63121C1.8278 6.86297 1.69633 7.17648 1.69349 7.50423C1.69064
            7.83198 1.81663 8.14773 2.04433 8.38348L9.11558 15.4547C9.34999 15.6891
            9.66787 15.8207 9.99933 15.8207C10.3308 15.8207 10.6487 15.6891 10.8831
            15.4547L17.9543 8.38348C18.1887 8.14907 18.3203 7.83119 18.3203 7.49973C18.3203
            7.16828 18.1887 6.85039 17.9543 6.61598Z"
              fill="#333333"
          />
        </svg>
      </button>
    </div>
    <div class="simple-keyboard"></div>
  </div>
</template>

<script>
import Keyboard from 'simple-keyboard'
import inputMask from 'simple-keyboard-input-mask'
import 'simple-keyboard/build/css/index.css'

export default {
  name: 'appVirtualKeyboard',
  props: {
    visible: Boolean,
    type: {
      type: String,
      default: 'phone',
      validator: (value) => ['phone', 'numeric', 'alpha'].includes(value)
    }
  },
  data() {
    return {
      keyboard: null,
    }
  },
  mounted() {
    this.initializeKeyboard()
    this.addGlobalListeners()
    document.body.append(this.$refs.keyboardContainer)
  },
  beforeUnmount() {
    document.body.remove(this.$refs.keyboardContainer)
    this.removeGlobalListeners()
  },
  beforeDestroy() {
    if (this.$refs.keyboardContainer && this.$refs.keyboardContainer.parentNode) {
      this.$refs.keyboardContainer.parentNode.removeChild(this.$refs.keyboardContainer)
      document.body.style.overflow = 'auto'
    }
  },
  watch: {
    visible(newValue) {
      document.body.style.overflow = newValue ? 'hidden' : ''
    },
    type() {
      if (this.keyboard) {
        this.keyboard.destroy()
        this.initializeKeyboard()
      }
    }
  },
  methods: {
    closeKeyboard() {
      this.$emit('close')
    },
    initializeKeyboard() {
      const commonOptions = {
        onChange: (input) => {
          this.$emit('input', input)
        },
        display: {
          '{bksp}': '⌫',
        },
        modules: [inputMask]
      }

      switch (this.type) {
        case 'phone':
          this.keyboard = new Keyboard({
            ...commonOptions,
            layout: {
              default: ['1 2 3', '4 5 6', '7 8 9', '0 {bksp}'],
            },
            inputMask: {
              'default': {
                mask: '+1 (999) 999-9999',
                regex: /^[0-9]+$/,
              },
            },
          })
          break
        case 'numeric':
          this.keyboard = new Keyboard({
            ...commonOptions,
            layout: {
              default: ['1 2 3', '4 5 6', '7 8 9', '0 {bksp}'],
            },
            inputMask: {
              'default': {
                regex: /^[0-9]+$/,
              },
            },
          })
          break
        case 'alpha':
          this.keyboard = new Keyboard({
            ...commonOptions,
            layout: {
              default: [
                'q w e r t y u i o p',
                'a s d f g h j k l',
                'z x c v b n m',
                '@ . _ - + {bksp}',
                '.com .ru'
              ],
            },
            inputMask: {
              'default': {
                regex: /^[a-zA-Z0-9@._-]+$/
              }
            }
          })
      }
    },
    addGlobalListeners() {
      document.addEventListener('mousedown', this.handleOutsideClick)
    },
    removeGlobalListeners() {
      document.removeEventListener('mousedown', this.handleOutsideClick)
      document.body.style.overflow = ''
    },
    handleOutsideClick(event) {
      const keyboardWrapper = this.$refs.keyboardContainer
      const inputElement = this.$parent.$refs.inputField

      if (this.$el && !this.$el.contains(event.target)
          && keyboardWrapper && !keyboardWrapper.contains(event.target)
          && inputElement && event.target !== inputElement
      ) {
        this.$emit('close')
      }
    },
  },
}
</script>
